<template>
    <div class="ainak-footer">
        <router-link to="/mobileapp" class="router-link-format">Mobile App</router-link>
        <router-link to="/pricing" class="router-link-format">Pricing</router-link>
        <a href="http://ainak.io" target="_blank" class="router-link-format">About Us</a>
        <a href="http://ainak.io/contact" target="_blank" class="router-link-format">Contact Us</a>
        <a href="http://ainak.io/privacy-policy" target="_blank" class="router-link-format">Privacy Policy</a>
        
        
        
    </div>
</template>

<script>
    export default {
        name: "AinakFooter"
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/css/colors.scss";

    .ainak-footer{
        display: flex;
        flex-direction: row;
        justify-content: center;

        .router-link-format{
            align-self: center;
            font-family: 'Roboto', sans-serif;
            font-size: 80%;
            color:  $body-text-color;
            flex: 1;
            font-weight: lighter;
            border-right: 1px solid #c8c8c8;
            cursor: pointer;
            text-decoration: none;
        }
        .router-link-format:hover{
            color: $primary-color;
            font-weight: bold;
        }

        .router-link-format:last-child{
        border: none;
        }
    }


</style>